<template>
  <div class="main">
    <div class="recommend1">
      <!-- <el-col :span="8"> -->
        <el-cascader style="width: 200px;margin-left: 144px;" clearable v-model="region" :options="regionTreeList" :props="{ value: 'label' }" @change="changeRegion"
          placeholder="请选择地区" />
      <!-- </el-col> -->
      <!-- <el-col :span="14" :offset="1" class="search"> -->
        <el-cascader style="width: 200px;margin-left: 12px;" clearable v-model="positionTypes" :options="positionTypeList"
          :props="{ value: 'positionTypeId', label: 'typeName' }" class="selectSearch" @change="getCompanyResumeList"
          placeholder="请选择职位类型" />
        <el-input style="width: 300px;margin-left: 12px;" placeholder="搜索毕业院校" v-model="keywords" class="searchInput"
          @keyup.enter.native="getCompanyResumeList" />
        <el-button icon="el-icon-search" type="primary" class="searchButton" @click="getCompanyResumeList"></el-button>
      <!-- </el-col> -->
    </div>
    <div class="recommend2">
      <div class="recommend2Item">
        <div>经验要求</div>
        <div class="filter">
          <div :class="{ active: jobYear == item.paramName, common: jobYear != item.paramName }"
            v-for="(item, index) in experience_required" :key="index" @click="switchFilter(item.paramName, 0)">
            {{ item.paramName }}
          </div>
        </div>
      </div>
      <div class="recommend2Item">
        <div>学历要求</div>
        <div class="filter">
          <div :class="{ active: educated == item.paramName, common: educated != item.paramName }"
            v-for="(item, index) in educatedList" :key="index" @click="switchFilter(item.paramName, 1)">
            {{ item.paramName }}
          </div>
        </div>
      </div>
      <div class="recommend2Item">
        <div>年龄要求</div>
        <div class="filter">
          <div :class="{ active: age == item.paramName, common: age != item.paramName }"
            v-for="(item, index) in age_type" :key="index" @click="switchFilter(item.paramName, 2)">
            {{ item.paramName }}
          </div>
        </div>
      </div>
      <div class="recommend2Item">
        <div>其他筛选</div>
        <div class="filter1">
          <el-col :span="7">
            <el-select clearable v-model="sex" placeholder="请选择性别" class="filterSelect" @change="getCompanyResumeList">
              <el-option v-for="(item, index) in gender_requirements" :key="index" :label="item.paramName"
                :value="item.paramName">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-select clearable v-model="salaryRange" placeholder="请选择薪资范围" class="filterSelect" @change="salary">
              <el-option v-for="(item, index) in salaryRangeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1" :offset="2">
            <el-button type="primary" @click="reset">重置</el-button>
          </el-col>
        </div>
      </div>
    </div>
    <div class="recommend3">
      <div class="recommend3Item" v-for="(item, index) in resumeList" :key="index">
        <div class="left">
          <div class="left1">
            <img :src="item.photo" />
            <div>{{ item.name }}</div>
            <div>{{ item.activeStatus == '0' ? '非活跃' : '刚刚活跃' }}</div>
          </div>
          <div class="left2">
            <span>{{ item.age }}岁</span>| <span>{{ item.jobYear }}年</span> | <span>{{ item.educated }}</span>|<span>{{
              item.expectedSalary }}</span>
          </div>
          <div class="left3">
            {{ item.briefly }}
          </div>
        </div>
        <div class="right">
          <el-timeline :reverse="reverse">
            <el-timeline-item>
              教育经历：{{ item.college }}
            </el-timeline-item>
            <el-timeline-item>
              工作期望：{{ item.workTime }} {{ item.workWeekend }} {{ item.everyWeek }}
            </el-timeline-item>
            <el-timeline-item>
              期望行业：{{ item.positionTypeName }}
            </el-timeline-item>
          </el-timeline>
        </div>

        <div class="btns">
          <div class="btnsItem" @click="seejianli(item)">查看简历</div>
          <div class="btnsItem" @click="goChat(item)">在线沟通</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>共{{ total }}个简历</div>
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog title="查看简历" :visible.sync="show">
      <!-- <el-form :model="resumeForm" class="form1" ref="resumeForm" label-width="70px">
        <el-form-item label="名字">
          <el-input v-model="resumeForm.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="resumeForm.phone" :disabled="true" />
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="resumeForm.sex" :disabled="true" />
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="resumeForm.age" :disabled="true" />
        </el-form-item>
        <el-form-item label="学历">
          <el-input v-model="resumeForm.educated" :disabled="true" />
        </el-form-item>
        <el-form-item label="工作年限">
          <el-input v-model="resumeForm.jobYear" :disabled="true" />
        </el-form-item>
        <el-form-item label="期望薪资">
          <el-input v-model="resumeForm.expectedSalary" :disabled="true" />
        </el-form-item>
        <el-form-item label="毕业院校">
          <el-input v-model="resumeForm.college" :disabled="true" />
        </el-form-item>
        <el-form-item label="应聘岗位">
          <el-input v-model="resumeForm.resName" :disabled="true" />
        </el-form-item>
        <el-form-item label="工作经验">
          <div style="    background-color: #F5F7FA;
    border-color: #E4E7ED;padding: 8px;line-height: 1.5;    color: #C0C4CC;">{{ resumeForm.newExperience }}</div>
        </el-form-item>
      </el-form> -->
      <el-descriptions title="基本信息" :column="3" border>
        <el-descriptions-item label="姓名">{{ resumeForm.name }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ resumeForm.sex }}</el-descriptions-item>
        <el-descriptions-item label="照片">
          <image-preview :src="resumeForm.photo" :width="67" :height="67" />
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="" :column="2" border>
        <el-descriptions-item label="出生日期">{{ resumeForm.birthDate }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ resumeForm.phone }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ resumeForm.email }}</el-descriptions-item>

        <el-descriptions-item label="身份">{{ resumeForm.identity }}</el-descriptions-item>

        <el-descriptions-item label="毕业学校">{{ resumeForm.college }}</el-descriptions-item>
        <el-descriptions-item label="学历">{{ resumeForm.educated }}</el-descriptions-item>

        <el-descriptions-item label="入学时间">{{ resumeForm.collegeDate }}</el-descriptions-item>
        <el-descriptions-item label="工作经验">{{ resumeForm.jobYear }}年</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="简述信息">{{ resumeForm.briefly
          }}</el-descriptions-item>

      </el-descriptions>
      <el-descriptions title="求职意向" :column="1" border>
        <el-descriptions-item label-class-name="experience_class" label="期望区域">{{ resumeForm.province }}-{{
          resumeForm.city }}-{{ resumeForm.area }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="期望行业">{{ resumeForm.positionOneName }}—{{
          resumeForm.positionTypeName }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="期望薪资">{{ resumeForm.expectedSalary
          }}</el-descriptions-item>

        <el-descriptions-item label-class-name="experience_class" label="工作时间">{{ resumeForm.workWeekend
          }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="工作时段">{{ resumeForm.workTime
          }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="每周工作">{{ resumeForm.everyWeek
          }}</el-descriptions-item>
      </el-descriptions>
      <!-- 工作经验 -->
      <el-descriptions title="项目经验" v-if="resumeForm.memberProjectExperienceList" :column="1" border />

      <el-descriptions v-for="(item, index) in resumeForm.memberProjectExperienceList" :key="index" title="" :column="1"
        border>
        <el-descriptions-item label-class-name="experience_class" label="项目名">{{ item.projectName
          }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="时间">{{ item.beginTime }}——{{ item.endTime
          }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="责任描述">{{ item.dutyInfo
          }}</el-descriptions-item>
      </el-descriptions>

      <!-- 技能证书 -->
      <el-descriptions title="技能证书" v-if="resumeForm.resumeCertificateList" :column="1" border />

      <el-descriptions v-for="(item, index) in resumeForm.resumeCertificateList" :key="index" title="" :column="1"
        border>
        <!-- <el-descriptions-item label-class-name="experience_class" label="技能">{{ item.skillType }}</el-descriptions-item> -->
        <el-descriptions-item label-class-name="experience_class" label="证书">{{ item.certificateType
          }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="证书图片">
          <image-preview v-for="(ite, i) in item.certificateImg" :key="i" :src="ite" :width="67" :height="67" />
        </el-descriptions-item>
      </el-descriptions>

    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      salaryRangeList: [
      {
          value: '不限',
          label: '不限'
        },
        {
          value: '1000~3000',
          label: '1000~3000'
        },
        {
          value: '3000~6000',
          label: '3000~6000'
        },
        {
          value: '6000~9000',
          label: '6000~9000'
        },
        {
          value: '9000~12000',
          label: '9000~12000'
        },
        {
          value: '12000~16000',
          label: '12000~16000'
        },
        {
          value: '16000以上',
          label: '16000以上'
        }
      ],
      salaryRange: '',
      pageNum: 1,
      active: "0",
      total: 10,
      keywords: "",
      positionOne: "",
      positionType: "",
      positionList: [],
      showShare: false,
      reverse: true,
      activities: [{
        content: '工作期望',
      }, {
        content: '教育经历',
      }],
      positionTypes: [],
      resumeList: [],
      positionTypeList: [],
      experience_required: [],
      age_type: [],
      educatedList: [],
      gender_requirements: [],
      regionTreeList: [],
      region: [],
      province: '',
      city: '',
      area: '',
      jobYear: '不限',
      educated: '不限',
      age: '不限',
      sex: '',
      expectedSalaryStart: '',
      expectedSalaryEnd: '',
      show: false,
      resumeForm: ''
    };
  },
  mounted() {
    this.getCompanyResumeList()
    this.getPositionListByPid1()
    this.getDictParamList()
    this.selectRegionTreeList()
  },
  methods: {
    seejianli(item) {
      this.show = true
      this.getMemberResumeInfo(item.resumeId)
    },


    goChat(item) {
      // this.$cookie.set("chatId", item.chatId);
      this.$cookie.set("JresumeId", item.resumeId);
      this.$router.push({ path: "/communicate" });
    },

    getMemberResumeInfo(resumeId) {
      console.log(resumeId);
      this.$get('/api/company/resume/getCompanyResumeInfo', {
        resumeId
      }).then(res => {
        if (res.data.resumeCertificateList) {
          res.data.resumeCertificateList.map(item => {
            if (item.certificateImg) {
              item.certificateImg = item.certificateImg.split(',')
            }
          })
        }
        this.resumeForm = res.data
      })
    },

    reset() {
      this.jobYear = '不限'
      this.educated = '不限'
      this.age = '不限'
      this.sex = ''
      this.expectedSalaryStart = ''
      this.expectedSalaryEnd = ''
      this.positionTypes = []
      this.keywords = ''
      this.region = []
      this.province = ''
      this.city = ''
      this.area = ''
      this.salaryRange = []
      this.getCompanyResumeList()
    },
    salary(value) {
      console.log(value);
      if (value == '不限') {
        this.expectedSalaryStart =''
        this.expectedSalaryEnd = ''
      }else{
        let str = value.split('~')
      //   console.log(str);
      // if (str.length == 1) {
      //   this.expectedSalaryStart = '16000'
      //   this.expectedSalaryEnd = '10000000'
      // } else {
        this.expectedSalaryStart = str[0]
        this.expectedSalaryEnd = str[1]
      // }
      }
 
      this.getCompanyResumeList()
    },
    changeRegion(value) {
      console.log(value);
      if (value == '不限') {
        this.province = ''
      this.city = ''
      this.area = ''
      }else{
        this.province = value[0]
      this.city = value[1]
      this.area = value[2]
      }
      this.getCompanyResumeList()
     
    },
    switchFilter(item, type) {
      console.log(item,type);
      if (type == 0) {
        this.jobYear = item
      } else if (type == 1) {
        this.educated = item
      } else if (type == 2) {
        this.age = item
      }
      this.getCompanyResumeList()
    },
    selectRegionTreeList() {
      this.$get('/api/common/selectRegionTreeList', {}).then(res => {
        res.data.unshift({
          id:-1,
          label:'不限'
        })
        this.regionTreeList = res.data
      })
    },
    getDictParamList() {
      this.$get("/api/common/getDictParamList", {
        paramType: 'experience_required',
      }).then((res) => {
        res.data.unshift({
          paramName: "不限",
          paramType:"experience_required",
        })
        this.experience_required = res.data
      });
      this.$get("/api/common/getDictParamList", {
        paramType: 'age_type',
      }).then((res) => {
         res.data.unshift({
          paramName: "不限",
          paramType:"age_type",
          value:'不限'
        })
        this.age_type = res.data
        // console.log(this.age_type);
      });
      this.$get("/api/common/getDictParamList", {
        paramType: 'educated',
      }).then((res) => {
         res.data.unshift({
          paramName: "不限",
          paramType:"educated"
        })
        this.educatedList = res.data
      });
      this.$get("/api/common/getDictParamList", {
        paramType: 'gender_requirements',
      }).then((res) => {
        this.gender_requirements = res.data
      });
    },
    loadCascaderOptions(node, resolve) {
      console.log(node)
      let id = node.value
      let level = node.level
      this.$get("/api/company/position/getPositionListByPid", {
        pid: id,
      }).then(res => {
        const nodes = Array.from(res.data, item => ({
          //于stream流差不多，将后台返回的数据进行处理
          value: item.positionTypeId, //选中项绑定值
          label: item.typeName,//标签上显示文字
          leaf: level == 1,//是否有子选项
        }))
        //将nodes返回
        resolve(nodes);
      });
    },
    getPositionListByPid1() {
      this.$get('/api/company/position/getPositionTypeListAll', {}).then(res => {
        res.data.unshift({
          typeName:'不限'
        })
        this.positionTypeList = res.data
      })
    },
    getCompanyResumeList() {
      this.$get("/api/company/resume/getCompanyResumeListForPC", {
        province: this.province,
        city: this.city,
        area: this.area,
        jobYear: this.jobYear == '不限'?'':this.jobYear,
        educated: this.educated == '不限'?'':this.educated,
        age: this.age == '不限'?'':this.age,
        sex: this.sex,
        expectedSalaryStart: this.expectedSalaryStart,
        expectedSalaryEnd: this.expectedSalaryEnd,
        positionOne: this.positionTypes[0],
        positionType: this.positionTypes[1],
        keywords: this.keywords,
        pageNum: this.pageNum,
        pageSize: 10
      }).then((res) => {
        this.resumeList = res.data.list;
        this.total = res.data.total;
      });
    },
    handleCurrentChange(value) {
      this.pageNum = value
      this.getCompanyResumeList()
    },
  }
};
</script>
<style scoped>
.main {
  padding: 0 30px;
}

.recommend1 {
  width: 100%;
  margin: 20px auto;
  display: flex;
  /* justify-content: center; */
}

.search {
  display: flex;
  align-items: center;
}

.searchButton {
  color: #FFFFFF;
}

.recommend2 {
  /* width: 100%; */
  /* height: 200px; */
  padding: 24px 40px;
  margin-bottom: 30px;
  background: #FFFFFF;
}

.recommend2Item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.recommend2Item>div:nth-of-type(1) {
  height: 22px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.filter {
  height: 38px;
  display: flex;
  margin-left: 50px;
}

.filter>div {
  padding: 8px 0;
  width: 100px;
  height: 22px;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}

.common {
  color: #555555;
}

.active {
  background-color: #0051aa;
  color: #ffffff;
}

.filter1 {
  height: 30px;
  margin-left: 50px;
}

.filterSelect {
  height: 30px;
  /* display: flex; */
}

/* .filterSelect ::v-deep .el-input__inner{
  height: 30px;
} */
.recommend3 {
  width: 100%;

  margin-bottom: 50px;
}

.recommend3Item {
  /* height: 140px; */
  padding: 20px 40px;
  background-color: #FFFFFF;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left1 {
  display: flex;
  align-items: center;
}

.left1>img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 14px;
  object-fit: cover;
}

.left1>div:nth-of-type(1) {
  height: 22px;
  margin-right: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.left1>div:nth-of-type(2) {
  height: 22px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #0051AA;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.left2 {
  height: 22px;
  font-family: PingFangSC-Regular, PingFangSC-Regular;
  font-weight: normal;
  font-size: 14px;
  color: #555555;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 10px;
  margin-bottom: 10px;
}

.left2>span:nth-of-type(1) {
  margin-left: 0;
}

.left2>span {
  margin-left: 20px;
  margin-right: 20px;
}

.left3 {
  width: 400px;
  /* height: 40px; */
  font-family: PingFangSC-Regular, PingFangSC-Regular;
  font-weight: normal;
  font-size: 14px;
  color: #555555;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  word-break: break-all
}

.right {
  width: 400px;
}

.footer {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btns {
  display: flex;
  align-items: center;
}

.btnsItem {
  color: #0051AA;
  cursor: pointer;
  margin-right: 10px;
}
</style>

<style>
.experience_class {
  width: 120px;
}
</style>